<template>
  <div class="turnos-management">
    <!-- Header Profesional -->
    <div class="header-section mb-4">
      <div class="header-card">
        <!-- Breadcrumb -->
        <div class="breadcrumb-section">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb-custom">
              <li class="breadcrumb-item">
                <i class="nc-icon nc-credit-card"></i>
                Planes
              </li>
              <li class="breadcrumb-item active">
                <i class="nc-icon nc-time-alarm"></i>
                Gestión de Turnos
              </li>
            </ol>
          </nav>
        </div>

        <!-- Main Header Content -->
        <div class="header-content">
          <div class="row align-items-center">
            <div class="col-lg-8 col-md-7">
              <div class="header-info">
                <div class="header-icon">
                  <div class="icon-wrapper">
                    <i class="nc-icon nc-time-alarm"></i>
                  </div>
                </div>
                <div class="header-text">
                  <h1 class="header-title">Gestión de Turnos</h1>
                  <p class="header-subtitle">
                    Configure y administre los horarios de acceso para los planes de membresía
                  </p>
                  <div class="header-badges">
                    <span class="badge badge-soft-primary">
                      <i class="nc-icon nc-calendar-60"></i>
                      Sistema de Horarios
                    </span>
                    <span class="badge badge-soft-success">
                      <i class="nc-icon nc-check-2"></i>
                      Control de Acceso
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-5">
              <div class="header-actions">
                <button 
                  class="btn btn-primary btn-create"
                  @click="openCreateModal"
                  :disabled="loading">
                  <i class="nc-icon nc-simple-add"></i>
                  <span class="btn-text">Crear Turno</span>
                </button>
                <div class="quick-stats">
                  <div class="stat-item">
                    <span class="stat-number">{{ kpis.totalTurnos }}</span>
                    <span class="stat-label">Total</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-number text-success">{{ kpis.turnosActivos }}</span>
                    <span class="stat-label">Activos</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-number text-danger">{{ kpis.turnosInactivos }}</span>
                    <span class="stat-label">Inactivos</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- KPIs y estadísticas -->
    <div class="row mb-4">
      <div class="col-md-3">
        <card class="card-stats">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-paper text-warning"></i>
                </div>
              </div>
              <div class="col-md-8 col-sm-8">
                <div class="numbers">
                  <p class="card-category">Total Turnos</p>
                  <p class="card-title">{{ kpis.totalTurnos }}</p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-3">
        <card class="card-stats">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-calendar-60 text-success"></i>
                </div>
              </div>
              <div class="col-md-8 col-sm-8">
                <div class="numbers">
                  <p class="card-category">Turnos Activos</p>
                  <p class="card-title">{{ kpis.turnosActivos }}</p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-3">
        <card class="card-stats">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-simple-remove text-danger"></i>
                </div>
              </div>
              <div class="col-md-8 col-sm-8">
                <div class="numbers">
                  <p class="card-category">Turnos Inactivos</p>
                  <p class="card-title">{{ kpis.turnosInactivos }}</p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-3">
        <card class="card-stats">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-diamond text-danger"></i>
                </div>
              </div>
              <div class="col-md-8 col-sm-8">
                <div class="numbers">
                  <p class="card-category">Todos los Días</p>
                  <p class="card-title">{{ kpis.turnosCompletos }}</p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- Filtros y búsqueda -->
    <div class="row mb-4">
      <div class="col-12">
        <card>
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="nc-icon nc-zoom-split"></i>
              Filtros de Búsqueda
            </h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Buscar por descripción</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    v-model="filters.descripcion"
                    placeholder="Nombre del turno..."
                    @input="debouncedSearch">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Días activos</label>
                  <select 
                    class="form-control" 
                    v-model="filters.diasActivos"
                    @change="applyFilters">
                    <option value="">Todos los días</option>
                    <option value="lunes">Lunes</option>
                    <option value="martes">Martes</option>
                    <option value="miercoles">Miércoles</option>
                    <option value="jueves">Jueves</option>
                    <option value="viernes">Viernes</option>
                    <option value="sabado">Sábado</option>
                    <option value="domingo">Domingo</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Elementos por página</label>
                  <select 
                    class="form-control" 
                    v-model="pagination.limit"
                    @change="applyFilters">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <button 
                  class="btn btn-secondary mr-2"
                  @click="clearFilters">
                  <i class="nc-icon nc-simple-remove"></i>
                  Limpiar Filtros
                </button>
                <button 
                  class="btn btn-info"
                  @click="applyFilters"
                  :disabled="loading">
                  <i class="nc-icon nc-zoom-split"></i>
                  {{ loading ? 'Buscando...' : 'Buscar' }}
                </button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- Tabla de turnos -->
    <div class="row">
      <div class="col-12">
        <card>
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col-md-6">
                <h5 class="card-title mb-0">
                  <i class="nc-icon nc-bullet-list-67"></i>
                  Lista de Turnos
                </h5>
              </div>
              <div class="col-md-6 text-right">
                <small class="text-muted">
                  Mostrando {{ paginationInfo.showing }} de {{ paginationInfo.total }} registros
                </small>
              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <!-- Loader -->
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
              <p class="mt-2 text-muted">Cargando turnos...</p>
            </div>

            <!-- Tabla -->
            <div v-else-if="turnos.length > 0" class="table-responsive">
              <table class="table table-hover">
                <thead class="bg-light">
                  <tr>
                    <th 
                      @click="setSorting('id')"
                      class="cursor-pointer">
                      ID 
                      <i v-if="sorting.field === 'id'" 
                         :class="sorting.direction === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                      <i v-else class="fa fa-sort text-muted"></i>
                    </th>
                    <th 
                      @click="setSorting('descripcionTurno')"
                      class="cursor-pointer">
                      Descripción 
                      <i v-if="sorting.field === 'descripcionTurno'" 
                         :class="sorting.direction === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                      <i v-else class="fa fa-sort text-muted"></i>
                    </th>
                    <th>Estado</th>
                    <th>Días Activos</th>
                    <th>Horarios</th>
                    <th 
                      @click="setSorting('createdAt')"
                      class="cursor-pointer">
                      Fecha Creación 
                      <i v-if="sorting.field === 'createdAt'" 
                         :class="sorting.direction === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                      <i v-else class="fa fa-sort text-muted"></i>
                    </th>
                    <th class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="turno in turnos" :key="turno.id">
                    <td>
                      <span class="badge badge-primary">{{ turno.id }}</span>
                    </td>
                    <td>
                      <strong>{{ turno.descripcionTurno }}</strong>
                    </td>
                    <td>
                      <span 
                        class="badge" 
                        :class="turno.activo ? 'badge-success' : 'badge-danger'">
                        {{ turno.activo ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td>
                      <div class="d-flex flex-wrap">
                        <span 
                          v-for="dia in getDiasActivos(turno)" 
                          :key="dia"
                          class="badge badge-success badge-sm mr-1 mb-1">
                          {{ dia }}
                        </span>
                      </div>
                    </td>
                    <td class="text-sm">
                      <div v-for="horario in getHorarios(turno)" :key="horario.dia" class="mb-1">
                        <strong>{{ horario.dia }}:</strong> {{ horario.inicio }} - {{ horario.fin }}
                      </div>
                    </td>
                    <td>
                      <small class="text-muted">
                        {{ formatDate(turno.createdAt) }}
                      </small>
                    </td>
                    <td class="text-center">
                      <button 
                        class="btn btn-info btn-sm mr-1"
                        @click="viewTurno(turno)"
                        title="Ver detalles">
                        <i class="nc-icon nc-zoom-split"></i>
                      </button>
                      <button 
                        class="btn btn-warning btn-sm mr-1"
                        @click="editTurno(turno)"
                        title="Editar">
                        <i class="nc-icon nc-ruler-pencil"></i>
                      </button>
                      <button 
                        class="btn btn-danger btn-sm"
                        @click="deleteTurno(turno)"
                        title="Eliminar">
                        <i class="nc-icon nc-simple-remove"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Estado vacío -->
            <div v-else class="text-center py-5">
              <div class="text-muted">
                <i class="nc-icon nc-time-alarm" style="font-size: 4em; opacity: 0.3;"></i>
                <h5 class="mt-3">No hay turnos disponibles</h5>
                <p v-if="filters.descripcion || filters.diasActivos">
                  No se encontraron turnos que coincidan con los filtros aplicados.
                </p>
                <p v-else>
                  Comience creando su primer turno.
                </p>
                <button 
                  v-if="!filters.descripcion && !filters.diasActivos"
                  class="btn btn-primary"
                  @click="openCreateModal">
                  <i class="nc-icon nc-simple-add"></i>
                  Crear Primer Turno
                </button>
              </div>
            </div>
          </div>

          <!-- Paginación -->
          <div v-if="turnos.length > 0" class="card-footer">
            <div class="row align-items-center">
              <div class="col-md-6">
                <small class="text-muted">
                  Página {{ pagination.page + 1 }} de {{ paginationInfo.totalPages }}
                </small>
              </div>
              <div class="col-md-6">
                <nav aria-label="Paginación de turnos">
                  <ul class="pagination pagination-sm justify-content-end mb-0">
                    <li class="page-item" :class="{ disabled: pagination.page === 0 }">
                      <button 
                        class="page-link"
                        @click="changePage(pagination.page - 1)"
                        :disabled="pagination.page === 0">
                        <i class="nc-icon nc-minimal-left"></i>
                      </button>
                    </li>
                    <li 
                      v-for="page in visiblePages" 
                      :key="page"
                      class="page-item" 
                      :class="{ active: page === pagination.page + 1 }">
                      <button 
                        class="page-link"
                        @click="changePage(page - 1)">
                        {{ page }}
                      </button>
                    </li>
                    <li class="page-item" :class="{ disabled: pagination.page >= paginationInfo.totalPages - 1 }">
                      <button 
                        class="page-link"
                        @click="changePage(pagination.page + 1)"
                        :disabled="pagination.page >= paginationInfo.totalPages - 1">
                        <i class="nc-icon nc-minimal-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- Modal de Crear/Editar Turno -->
    <modal 
      :show.sync="showCreateEditModal"
      modalClasses="modal-lg"
      headerClasses="bg-primary text-white">
      
      <template slot="header">
        <h5 class="modal-title text-white">
          <i class="nc-icon nc-time-alarm mr-2"></i>
          {{ isEditMode ? 'Editar Turno' : 'Crear Nuevo Turno' }}
        </h5>
      </template>

      <template slot="default">
            <form @submit.prevent="saveTurno">
              <!-- Información básica -->
              <div class="form-group">
                <label for="descripcionTurno">
                  <strong>Descripción del Turno</strong>
                  <span class="text-danger">*</span>
                </label>
                <input 
                  type="text" 
                  class="form-control"
                  id="descripcionTurno"
                  v-model="turnoForm.descripcionTurno"
                  :class="{ 'is-invalid': turnoForm.errors.descripcionTurno }"
                  placeholder="Ej: Turno Mañana, Turno Tarde, etc."
                  maxlength="500"
                  required>
                <div v-if="turnoForm.errors.descripcionTurno" class="invalid-feedback">
                  {{ turnoForm.errors.descripcionTurno }}
                </div>
                <small class="form-text text-muted">
                  Máximo 500 caracteres. {{ 500 - (turnoForm.descripcionTurno ? turnoForm.descripcionTurno.length : 0) }} restantes.
                </small>
              </div>

              <!-- Configuración de días -->
              <div class="row">
                <div class="col-12">
                  <h6 class="mb-3">
                    <i class="nc-icon nc-calendar-60"></i>
                    Configuración de Días
                  </h6>
                </div>
              </div>

                             <!-- Días de la semana -->
               <div class="row mb-4">
                 <div 
                   v-for="dia in diasSemana" 
                   :key="dia.key"
                   class="col-md-4 col-lg-4">
                   <div class="card mb-3 day-card" :class="{ 'border-success': turnoForm[dia.key + 'Autorizado'] }">
                    <div class="card-header p-2">
                      <div class="custom-control custom-switch">
                        <input 
                          type="checkbox" 
                          class="custom-control-input"
                          :id="dia.key + 'Autorizado'"
                          v-model="turnoForm[dia.key + 'Autorizado']">
                        <label 
                          class="custom-control-label font-weight-bold" 
                          :for="dia.key + 'Autorizado'">
                          {{ dia.label }}
                        </label>
                      </div>
                    </div>
                    <div 
                      v-if="turnoForm[dia.key + 'Autorizado']" 
                      class="card-body p-2">
                      <div class="row">
                        <div class="col-6">
                          <label class="small">Hora Inicio</label>
                          <input 
                            type="time" 
                            class="form-control time-input"
                            v-model="turnoForm[dia.key + 'HoraInicio']"
                            :class="{ 'is-invalid': turnoForm.errors[dia.key + 'HoraInicio'] }"
                            step="1">
                          <div v-if="turnoForm.errors[dia.key + 'HoraInicio']" class="invalid-feedback">
                            {{ turnoForm.errors[dia.key + 'HoraInicio'] }}
                          </div>
                        </div>
                        <div class="col-6">
                          <label class="small">Hora Fin</label>
                          <input 
                            type="time" 
                            class="form-control time-input"
                            v-model="turnoForm[dia.key + 'HoraTermino']"
                            :class="{ 'is-invalid': turnoForm.errors[dia.key + 'HoraTermino'] }"
                            step="1">
                          <div v-if="turnoForm.errors[dia.key + 'HoraTermino']" class="invalid-feedback">
                            {{ turnoForm.errors[dia.key + 'HoraTermino'] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Errores generales -->
              <div v-if="turnoForm.errors.general" class="alert alert-danger">
                <i class="nc-icon nc-simple-remove"></i>
                {{ turnoForm.errors.general }}
              </div>
            </form>
        </template>

        <template slot="footer">
          <div class="modal-footer-custom">
            <button 
              type="button" 
              class="btn btn-secondary btn-modal"
              @click="showCreateEditModal = false">
              <i class="nc-icon nc-simple-remove"></i>
              Cancelar
            </button>
            <button 
              type="button" 
              class="btn btn-primary btn-modal"
              @click="saveTurno"
              :disabled="turnoForm.saving">
              <i v-if="turnoForm.saving" class="spinner-border spinner-border-sm mr-2"></i>
              <i v-else class="nc-icon nc-check-2 mr-2"></i>
              {{ turnoForm.saving ? 'Guardando...' : (isEditMode ? 'Actualizar' : 'Crear') }}
            </button>
          </div>
        </template>
    </modal>

    <!-- Modal de Ver Detalles -->
    <modal 
      :show.sync="showViewModal"
      modalClasses="modal-lg"
      headerClasses="bg-info text-white">
      
      <template slot="header">
        <h5 class="modal-title text-white">
          <i class="nc-icon nc-zoom-split mr-2"></i>
          Detalles del Turno
        </h5>
      </template>

      <template slot="default" v-if="selectedTurno">
            <!-- Información básica -->
            <div class="row mb-4">
              <div class="col-md-6">
                <h6 class="text-primary">Información General</h6>
                <table class="table table-sm">
                  <tr>
                    <td><strong>ID:</strong></td>
                    <td><span class="badge badge-primary">{{ selectedTurno.id }}</span></td>
                  </tr>
                  <tr>
                    <td><strong>Descripción:</strong></td>
                    <td>{{ selectedTurno.descripcionTurno }}</td>
                  </tr>
                  <tr>
                    <td><strong>Estado:</strong></td>
                    <td>
                      <span class="badge badge-success" v-if="selectedTurno.activo">Activo</span>
                      <span class="badge badge-secondary" v-else>Inactivo</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-md-6">
                <h6 class="text-primary">Fechas</h6>
                <table class="table table-sm">
                  <tr>
                    <td><strong>Creado:</strong></td>
                    <td>{{ formatDate(selectedTurno.createdAt) }}</td>
                  </tr>
                  <tr>
                    <td><strong>Actualizado:</strong></td>
                    <td>{{ formatDate(selectedTurno.updatedAt) }}</td>
                  </tr>
                  <tr>
                    <td><strong>Días Activos:</strong></td>
                    <td>{{ getDiasActivos(selectedTurno).length }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Horarios detallados -->
            <div class="row">
              <div class="col-12">
                <h6 class="text-primary">Horarios por Día</h6>
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead class="bg-light">
                      <tr>
                        <th>Día</th>
                        <th>Estado</th>
                        <th>Hora Inicio</th>
                        <th>Hora Término</th>
                        <th>Duración</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="dia in diasSemana" :key="dia.key">
                        <td><strong>{{ dia.label }}</strong></td>
                        <td>
                          <span 
                            v-if="selectedTurno[dia.key + 'Autorizado']" 
                            class="badge badge-success">
                            Autorizado
                          </span>
                          <span v-else class="badge badge-secondary">No autorizado</span>
                        </td>
                        <td>
                          {{ selectedTurno[dia.key + 'Autorizado'] ? selectedTurno[dia.key + 'HoraInicio'] : '-' }}
                        </td>
                        <td>
                          {{ selectedTurno[dia.key + 'Autorizado'] ? selectedTurno[dia.key + 'HoraTermino'] : '-' }}
                        </td>
                        <td>
                          {{ selectedTurno[dia.key + 'Autorizado'] ? calculateDuration(selectedTurno[dia.key + 'HoraInicio'], selectedTurno[dia.key + 'HoraTermino']) : '-' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
        </template>

        <template slot="footer">
          <div class="modal-footer-custom">
            <button 
              type="button" 
              class="btn btn-secondary btn-modal"
              @click="showViewModal = false">
              <i class="nc-icon nc-simple-remove"></i>
              Cerrar
            </button>
            <button 
              type="button" 
              class="btn btn-warning btn-modal"
              @click="editTurnoFromView">
              <i class="nc-icon nc-ruler-pencil"></i>
              Editar
            </button>
          </div>
        </template>
    </modal>
  </div>
</template>

<script>
import { Card, Modal } from "src/components/UIComponents";

export default {
  name: "TurnosManagement",
  components: {
    Card,
    Modal,
  },
  data() {
    return {
      // Estados principales
      loading: false,
      turnos: [],
      selectedTurno: null,
      isEditMode: false,

      // Estados de modales
      showCreateEditModal: false,
      showViewModal: false,

      // KPIs
      kpis: {
        totalTurnos: 0,
        turnosActivos: 0,
        turnosInactivos: 0,
        turnosFinDeSemana: 0,
        turnosCompletos: 0,
      },

      // Filtros
      filters: {
        descripcion: "",
        diasActivos: "",
      },

      // Paginación
      pagination: {
        page: 0,
        limit: 20,
        totalRecords: 0,
        totalPages: 0,
        hasNext: false,
        hasPrev: false,
      },

      // Ordenamiento
      sorting: {
        field: "id",
        direction: "asc",
      },

      // Formulario de turno
      turnoForm: {
        id: null,
        descripcionTurno: "",
        lunesAutorizado: false,
        martesAutorizado: false,
        miercolesAutorizado: false,
        juevesAutorizado: false,
        viernesAutorizado: false,
        sabadoAutorizado: false,
        domingoAutorizado: false,
        lunesHoraInicio: "06:00",
        lunesHoraTermino: "22:00",
        martesHoraInicio: "06:00",
        martesHoraTermino: "22:00",
        miercolesHoraInicio: "06:00",
        miercolesHoraTermino: "22:00",
        juevesHoraInicio: "06:00",
        juevesHoraTermino: "22:00",
        viernesHoraInicio: "06:00",
        viernesHoraTermino: "22:00",
        sabadoHoraInicio: "08:00",
        sabadoHoraTermino: "20:00",
        domingoHoraInicio: "08:00",
        domingoHoraTermino: "18:00",
        saving: false,
        errors: {},
      },

      // Configuración de días
      diasSemana: [
        { key: "lunes", label: "Lunes" },
        { key: "martes", label: "Martes" },
        { key: "miercoles", label: "Miércoles" },
        { key: "jueves", label: "Jueves" },
        { key: "viernes", label: "Viernes" },
        { key: "sabado", label: "Sábado" },
        { key: "domingo", label: "Domingo" },
      ],

      // Debounce timer
      debounceTimer: null,
    };
  },

  computed: {
    // Información de paginación
    paginationInfo() {
      const start = this.pagination.page * this.pagination.limit + 1;
      const end = Math.min(
        (this.pagination.page + 1) * this.pagination.limit,
        this.pagination.totalRecords
      );
      return {
        showing: this.pagination.totalRecords > 0 ? `${start}-${end}` : "0",
        total: this.pagination.totalRecords,
        totalPages: this.pagination.totalPages,
      };
    },

    // Páginas visibles en la paginación
    visiblePages() {
      const currentPage = this.pagination.page + 1;
      const totalPages = this.pagination.totalPages;
      const pages = [];

      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + 4);

      if (end - start < 4) {
        start = Math.max(1, end - 4);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },

  methods: {
    // ========================================
    // MÉTODOS DE CARGA Y ACTUALIZACIÓN
    // ========================================

    async fetchTurnos(showLoading = true) {
      try {
        if (showLoading) {
          this.loading = true;
        }

        const requestBody = {
          Header: {
            Operacion: "/v1/turno/consultar-paginados",
          },
          Auth: {
            Token: sessionStorage.getItem("jCxbraoQeD"),
          },
          Parameters: {
            page: this.pagination.page,
            limit: this.pagination.limit,
            sortField: this.sorting.field,
            sortDirection: this.sorting.direction,
          },
          Body: {},
        };

        if (this.filters.descripcion) {
          requestBody.Parameters.descripcion = this.filters.descripcion;
        }

        if (this.filters.diasActivos) {
          requestBody.Parameters.diasActivos = [this.filters.diasActivos];
        }

        this.$logger.log("🔄 Consultando turnos con parámetros:", requestBody);

        const response = await this.$CentralGymOPS_API.post("", requestBody, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.data && response.data.success) {
          this.turnos = response.data.data.turnos || [];
          
          const pagination = response.data.data.pagination;
          this.pagination.totalRecords = pagination.totalRecords;
          this.pagination.totalPages = pagination.totalPages;
          this.pagination.hasNext = pagination.hasNext;
          this.pagination.hasPrev = pagination.hasPrev;

          // Actualizar KPIs con los valores reales del resumenEstados
          if (response.data.data.resumenEstados) {
            const resumen = response.data.data.resumenEstados;
            this.kpis.totalTurnos = resumen.totalGeneral || pagination.totalRecords;
            this.kpis.turnosActivos = resumen.totalActivos || 0;
            this.kpis.turnosInactivos = resumen.totalInactivos || 0;
          }
          
          // Calcular turnos completos (todos los días) desde los datos recibidos
          if (this.turnos.length > 0) {
            this.kpis.turnosCompletos = this.turnos.filter(turno => 
              turno.activo && turno.totalDiasActivos === 7
            ).length;
          }

          this.$logger.log("✅ Turnos cargados:", {
            total: this.turnos.length,
            paginacion: this.pagination,
            resumenEstados: response.data.data.resumenEstados,
          });
        } else {
          throw new Error(response.data?.error?.message || "Error desconocido");
        }
      } catch (error) {
        this.$logger.error("❌ Error cargando turnos:", error);
        this.handleApiError(error);
      } finally {
        if (showLoading) {
          this.loading = false;
        }
      }
    },

    // Método deprecado - Los KPIs ahora se actualizan desde fetchTurnos usando resumenEstados
    // async fetchTurnosResumen() {
    //   try {
    //     const requestBody = {
    //       Header: {
    //         Operacion: "/v1/turno/consultar-por-empresa",
    //       },
    //       Auth: {
    //         Token: sessionStorage.getItem("jCxbraoQeD"),
    //       },
    //       Parameters: {},
    //       Body: {},
    //     };

    //     const response = await this.$CentralGymOPS_API.post("", requestBody, {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     });

    //     if (response.data && response.data.success) {
    //       const resumen = response.data.data.resumen;
    //       this.kpis.totalTurnos = resumen.totalTurnos || 0;
    //       this.kpis.turnosCompletos = resumen.turnosConTodosLosDias || 0;
    //       this.kpis.turnosFinDeSemana = resumen.turnosFinDeSemana || 0;
    //       this.kpis.turnosActivos = resumen.turnosActivos || resumen.totalTurnos || 0;
    //     }
    //   } catch (error) {
    //     this.$logger.error("❌ Error cargando resumen:", error);
    //   }
    // },

    // ========================================
    // MÉTODOS CRUD
    // ========================================

    openCreateModal() {
      this.isEditMode = false;
      this.resetForm();
      this.showCreateEditModal = true;
    },

    editTurno(turno) {
      this.isEditMode = true;
      this.fillFormWithTurno(turno);
      this.showCreateEditModal = true;
    },

    editTurnoFromView() {
      if (this.selectedTurno) {
        this.showViewModal = false;
        this.editTurno(this.selectedTurno);
      }
    },

    viewTurno(turno) {
      this.selectedTurno = turno;
      this.showViewModal = true;
    },

    async saveTurno() {
      try {
        this.turnoForm.saving = true;
        this.turnoForm.errors = {};

        // Validar formulario
        if (!this.validateForm()) {
          return;
        }

        // Preparar datos
        const turnoData = this.prepareTurnoData();

        // Determinar operación
        const operation = this.isEditMode 
          ? "/v1/turno/actualizar" 
          : "/v1/turno/crear";

        const requestBody = {
          Header: {
            Operacion: operation,
          },
          Auth: {
            Token: sessionStorage.getItem("jCxbraoQeD"),
          },
          Parameters: this.isEditMode ? { turnoId: this.turnoForm.id } : {},
          Body: turnoData,
        };

        this.$logger.log(`🔄 ${this.isEditMode ? 'Actualizando' : 'Creando'} turno:`, requestBody);

        const response = await this.$CentralGymOPS_API.post("", requestBody, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.data && response.data.success) {
          this.$swal.fire({
            icon: "success",
            title: "¡Éxito!",
            text: response.data.data.message || 
                  `Turno ${this.isEditMode ? 'actualizado' : 'creado'} correctamente`,
            confirmButtonColor: "#6bd098",
          });

          this.showCreateEditModal = false;
          await this.fetchTurnos(false); // No loading individual después de crear/editar
        } else {
          throw new Error(response.data?.error?.message || "Error desconocido");
        }
      } catch (error) {
        this.$logger.error("❌ Error guardando turno:", error);
        this.handleApiError(error);
      } finally {
        this.turnoForm.saving = false;
      }
    },

    async deleteTurno(turno) {
      try {
        // Verificar si es eliminación lógica (desactivar) o física (eliminar permanentemente)
        const isLogicalDelete = turno.activo;
        
        const confirmOptions = isLogicalDelete ? {
          title: "¿Desactivar turno?",
          html: `
            <div style="text-align: center;">
              <div style="font-size: 48px; color: #f39c12; margin-bottom: 20px;">
                <i class="nc-icon nc-simple-remove"></i>
              </div>
              <p style="margin-bottom: 15px; color: #666;">
                <strong>${turno.descripcionTurno}</strong>
              </p>
              <p style="margin-bottom: 10px; color: #666;">
                El turno será desactivado. Podrá reactivarlo más tarde o eliminarlo permanentemente.
              </p>
              <p style="font-size: 14px; color: #999;">
                Esta acción es reversible.
              </p>
            </div>
          `,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f39c12",
          cancelButtonColor: "#6c757d",
          confirmButtonText: '<i class="nc-icon nc-simple-remove"></i> Desactivar',
          cancelButtonText: '<i class="nc-icon nc-simple-remove"></i> Cancelar',
          backdrop: `rgba(0,26,0,0.4)`,
          allowOutsideClick: false,
        } : {
          title: "¿Eliminar permanentemente?",
          html: `
            <div style="text-align: center;">
              <div style="font-size: 48px; color: #dc3545; margin-bottom: 20px;">
                <i class="nc-icon nc-simple-remove"></i>
              </div>
              <p style="margin-bottom: 15px; color: #666;">
                <strong>${turno.descripcionTurno}</strong>
              </p>
              <p style="margin-bottom: 10px; color: #666;">
                <strong>¡ATENCIÓN!</strong> El turno será eliminado permanentemente.
              </p>
              <p style="font-size: 14px; color: #dc3545; font-weight: bold;">
                Esta acción NO se puede deshacer.
              </p>
            </div>
          `,
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#6c757d",
          confirmButtonText: '<i class="nc-icon nc-simple-remove"></i> Eliminar permanentemente',
          cancelButtonText: '<i class="nc-icon nc-simple-remove"></i> Cancelar',
          backdrop: `rgba(0,0,0,0.4)`,
          allowOutsideClick: false,
        };
        
        const result = await this.$swal.fire(confirmOptions);

        if (result.isConfirmed) {
          this.loading = true;

          const requestBody = {
            Header: {
              Operacion: "/v1/turno/eliminar",
            },
            Auth: {
              Token: sessionStorage.getItem("jCxbraoQeD"),
            },
            Parameters: {
              turnoId: turno.id,
            },
            Body: {},
          };

          const response = await this.$CentralGymOPS_API.post("", requestBody, {
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (response.data && response.data.success) {
            this.$swal.fire({
              icon: "success",
              title: isLogicalDelete ? "¡Desactivado!" : "¡Eliminado!",
              text: response.data.data.message || 
                    (isLogicalDelete ? "Turno desactivado correctamente" : "Turno eliminado permanentemente"),
              confirmButtonColor: "#6bd098",
            });

            await this.fetchTurnos(false); // No loading individual después de eliminar
          } else {
            throw new Error(response.data?.error?.message || "Error desconocido");
          }
        }
      } catch (error) {
        this.$logger.error("❌ Error eliminando turno:", error);
        this.handleApiError(error);
      } finally {
        this.loading = false;
      }
    },

    // ========================================
    // MÉTODOS DE UTILIDAD
    // ========================================

    validateForm() {
      const errors = {};

      // Validar descripción
      if (!this.turnoForm.descripcionTurno || !this.turnoForm.descripcionTurno.trim()) {
        errors.descripcionTurno = "La descripción es requerida";
      } else if (this.turnoForm.descripcionTurno.length > 500) {
        errors.descripcionTurno = "La descripción no puede exceder 500 caracteres";
      }

      // Validar que al menos un día esté autorizado
      const diasAutorizados = this.diasSemana.some(dia => 
        this.turnoForm[dia.key + 'Autorizado']
      );

      if (!diasAutorizados) {
        errors.general = "Debe autorizar al menos un día de la semana";
      }

      // Validar horarios para días autorizados
      this.diasSemana.forEach(dia => {
        if (this.turnoForm[dia.key + 'Autorizado']) {
          const inicio = this.turnoForm[dia.key + 'HoraInicio'];
          const termino = this.turnoForm[dia.key + 'HoraTermino'];

          if (!inicio) {
            errors[dia.key + 'HoraInicio'] = "Hora de inicio requerida";
          }

          if (!termino) {
            errors[dia.key + 'HoraTermino'] = "Hora de término requerida";
          }

          if (inicio && termino && inicio >= termino) {
            errors[dia.key + 'HoraTermino'] = "La hora de término debe ser mayor que la de inicio";
          }
        }
      });

      this.turnoForm.errors = errors;
      return Object.keys(errors).length === 0;
    },

    prepareTurnoData() {
      const data = {
        descripcionTurno: this.turnoForm.descripcionTurno.trim(),
      };

      // Agregar configuración de días
      this.diasSemana.forEach(dia => {
        data[dia.key + 'Autorizado'] = this.turnoForm[dia.key + 'Autorizado'];
        
        if (this.turnoForm[dia.key + 'Autorizado']) {
          data[dia.key + 'HoraInicio'] = this.formatTimeForAPI(this.turnoForm[dia.key + 'HoraInicio']);
          data[dia.key + 'HoraTermino'] = this.formatTimeForAPI(this.turnoForm[dia.key + 'HoraTermino']);
        }
      });

      return data;
    },

    formatTimeForAPI(time) {
      // Asegurar formato HH:mm:ss
      if (time && time.length === 5) {
        return time + ":00";
      }
      return time;
    },

    resetForm() {
      this.turnoForm = {
        id: null,
        descripcionTurno: "",
        lunesAutorizado: false,
        martesAutorizado: false,
        miercolesAutorizado: false,
        juevesAutorizado: false,
        viernesAutorizado: false,
        sabadoAutorizado: false,
        domingoAutorizado: false,
        lunesHoraInicio: "06:00",
        lunesHoraTermino: "22:00",
        martesHoraInicio: "06:00",
        martesHoraTermino: "22:00",
        miercolesHoraInicio: "06:00",
        miercolesHoraTermino: "22:00",
        juevesHoraInicio: "06:00",
        juevesHoraTermino: "22:00",
        viernesHoraInicio: "06:00",
        viernesHoraTermino: "22:00",
        sabadoHoraInicio: "08:00",
        sabadoHoraTermino: "20:00",
        domingoHoraInicio: "08:00",
        domingoHoraTermino: "18:00",
        saving: false,
        errors: {},
      };
    },

    fillFormWithTurno(turno) {
      this.turnoForm.id = turno.id;
      this.turnoForm.descripcionTurno = turno.descripcionTurno;

      this.diasSemana.forEach(dia => {
        this.turnoForm[dia.key + 'Autorizado'] = turno[dia.key + 'Autorizado'] || false;
        this.turnoForm[dia.key + 'HoraInicio'] = this.formatTimeForForm(turno[dia.key + 'HoraInicio']);
        this.turnoForm[dia.key + 'HoraTermino'] = this.formatTimeForForm(turno[dia.key + 'HoraTermino']);
      });

      this.turnoForm.errors = {};
    },

    formatTimeForForm(time) {
      // Convertir HH:mm:ss a HH:mm para inputs type="time"
      if (time && time.length >= 5) {
        return time.substring(0, 5);
      }
      return time;
    },

    getDiasActivos(turno) {
      return this.diasSemana
        .filter(dia => turno[dia.key + 'Autorizado'])
        .map(dia => dia.label.substring(0, 3).toUpperCase());
    },

    getHorarios(turno) {
      return this.diasSemana
        .filter(dia => turno[dia.key + 'Autorizado'])
        .map(dia => ({
          dia: dia.label.substring(0, 3),
          inicio: turno[dia.key + 'HoraInicio'] ? turno[dia.key + 'HoraInicio'].substring(0, 5) : '',
          fin: turno[dia.key + 'HoraTermino'] ? turno[dia.key + 'HoraTermino'].substring(0, 5) : '',
        }))
        .slice(0, 3); // Mostrar máximo 3 para no saturar la tabla
    },

    calculateDuration(inicio, termino) {
      if (!inicio || !termino) return '';
      
      const [horaInicio, minInicio] = inicio.split(':').map(Number);
      const [horaTermino, minTermino] = termino.split(':').map(Number);
      
      const minutosInicio = horaInicio * 60 + minInicio;
      const minutosTermino = horaTermino * 60 + minTermino;
      
      const duracionMinutos = minutosTermino - minutosInicio;
      const horas = Math.floor(duracionMinutos / 60);
      const minutos = duracionMinutos % 60;
      
      return `${horas}h ${minutos}m`;
    },

    formatDate(date) {
      if (!date) return '';
      return this.$moment(date).format('DD/MM/YYYY HH:mm');
    },

    handleApiError(error) {
      let message = "Ha ocurrido un error inesperado";
      
      if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
        message = error.response.data.error.message;
      } else if (error.message) {
        message = error.message;
      }

      this.$swal.fire({
        icon: "error",
        title: "Error",
        text: message,
        confirmButtonColor: "#6bd098",
      });
    },

    // ========================================
    // MÉTODOS DE FILTRADO Y PAGINACIÓN
    // ========================================

    applyFilters() {
      this.pagination.page = 0;
      this.fetchTurnos(true); // Mostrar loading en filtros
    },

    clearFilters() {
      this.filters.descripcion = "";
      this.filters.diasActivos = "";
      this.applyFilters();
    },

    debouncedSearch() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.applyFilters();
      }, 500);
    },

    changePage(page) {
      if (page >= 0 && page < this.pagination.totalPages) {
        this.pagination.page = page;
        this.fetchTurnos(true); // Mostrar loading en cambio de página
      }
    },

    setSorting(field) {
      if (this.sorting.field === field) {
        this.sorting.direction = this.sorting.direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sorting.field = field;
        this.sorting.direction = 'asc';
      }
      this.pagination.page = 0;
      this.fetchTurnos(true); // Mostrar loading en ordenamiento
    },
  },

  async mounted() {
    this.$logger.log("🚀 Inicializando gestión de turnos...");
    
    // Mostrar loading inicial
    this.loading = true;
    
    try {
      // Cerrar cualquier modal de SweetAlert que pueda estar abierto
      if (this.$swal && this.$swal.close) {
        this.$swal.close();
      }

      await this.fetchTurnos(false); // No mostrar loading individual, usa el global
      
      this.$logger.log("✅ Gestión de turnos inicializada correctamente");
    } catch (error) {
      this.$logger.error("❌ Error inicializando gestión de turnos:", error);
      
      // Mostrar error al usuario
      this.$swal.fire({
        icon: "error",
        title: "Error de Inicialización",
        text: "No se pudo cargar la información de turnos. Por favor, recarga la página.",
        confirmButtonColor: "#6bd098",
      });
    } finally {
      // Asegurar que el loading se cierre siempre
      this.loading = false;
    }
  },

  beforeDestroy() {
    // Limpiar timer de debounce
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
};
</script>

<style scoped>
.turnos-management {
  padding: 1rem;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  background-color: #f8f9fa;
}

.table th {
  border-top: none;
  font-weight: 600;
  color: #6c757d;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table td {
  vertical-align: middle;
}

.badge-sm {
  font-size: 0.75em;
  padding: 0.25em 0.4em;
}

.card-stats .numbers {
  font-size: 1.5em;
  font-weight: bold;
}

.card-stats .card-category {
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0;
  font-weight: 500;
}

.text-sm {
  font-size: 0.875rem;
}

.custom-control-label {
  color: #495057;
}

.modal-header.bg-primary {
  border-bottom: 1px solid #dee2e6;
}

.modal-header.bg-info {
  border-bottom: 1px solid #dee2e6;
}

.form-control:focus {
  border-color: #6bd098;
  box-shadow: 0 0 0 0.2rem rgba(107, 208, 152, 0.25);
}

.btn-primary {
  background-color: #6bd098;
  border-color: #6bd098;
}

.btn-primary:hover {
  background-color: #5cb85c;
  border-color: #5cb85c;
}

.pagination .page-link {
  color: #6bd098;
  border-color: #dee2e6;
}

.pagination .page-item.active .page-link {
  background-color: #6bd098;
  border-color: #6bd098;
}

.pagination .page-link:hover {
  color: #5cb85c;
  background-color: #f8f9fa;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.alert {
  border: none;
  border-radius: 0.375rem;
}

.invalid-feedback {
  font-size: 0.875rem;
}

.is-invalid {
  border-color: #dc3545;
}

.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #6bd098;
  border-color: #6bd098;
}

.icon-big {
  font-size: 2.5rem;
  opacity: 0.8;
}

/* ========================================
   HEADER PROFESIONAL STYLES
======================================== */

.header-section {
  margin-bottom: 2rem;
}

.header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
}

.header-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(107, 208, 152, 0.9) 0%, rgba(94, 185, 144, 0.95) 100%);
  z-index: 1;
}

.breadcrumb-section {
  position: relative;
  z-index: 2;
  padding: 15px 25px 0;
}

.breadcrumb-custom {
  background: none;
  margin-bottom: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
}

.breadcrumb-custom .breadcrumb-item {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.breadcrumb-custom .breadcrumb-item.active {
  color: white;
  font-weight: 600;
}

.breadcrumb-custom .breadcrumb-item + .breadcrumb-item::before {
  content: "›";
  margin: 0 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.1rem;
}

.breadcrumb-custom .breadcrumb-item i {
  margin-right: 5px;
  font-size: 0.9rem;
}

.header-content {
  position: relative;
  z-index: 2;
  padding: 20px 25px 30px;
}

.header-info {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.header-icon {
  flex-shrink: 0;
}

.icon-wrapper {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.icon-wrapper i {
  font-size: 2.2rem;
  color: white;
}

.header-text {
  flex: 1;
  min-width: 0;
}

.header-title {
  color: white;
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  font-weight: 400;
  margin-bottom: 15px;
  line-height: 1.5;
  max-width: 500px;
}

.header-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.badge-soft-primary,
.badge-soft-success {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  backdrop-filter: blur(10px);
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.badge-soft-primary i,
.badge-soft-success i {
  font-size: 0.75rem;
}

.header-actions {
  text-align: right;
}

.btn-create {
  background: white;
  color: #667eea;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
}

.btn-create:hover {
  background: #f8f9ff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  color: #5a67d8;
}

.btn-create:disabled {
  opacity: 0.7;
  transform: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.btn-create i {
  font-size: 1.1rem;
}

.quick-stats {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.stat-item {
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 12px;
  border-radius: 10px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  min-width: 50px;
}

.stat-number {
  display: block;
  color: white;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1;
}

.stat-number.text-success {
  color: #6bd098 !important;
}

.stat-number.text-danger {
  color: #dc3545 !important;
}

.stat-label {
  display: block;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 2px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-info {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .header-icon {
    align-self: center;
  }
  
  .header-title {
    font-size: 1.8rem;
  }
  
  .header-subtitle {
    font-size: 1rem;
  }
  
  .header-actions {
    text-align: center;
    margin-top: 20px;
  }
  
  .quick-stats {
    justify-content: center;
    margin-top: 15px;
  }
  
  .breadcrumb-custom {
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .header-content {
    padding: 15px 20px 25px;
  }
  
  .breadcrumb-section {
    padding: 10px 20px 0;
  }
  
  .header-title {
    font-size: 1.6rem;
  }
  
  .header-badges {
    justify-content: center;
  }
  
  .icon-wrapper {
    width: 60px;
    height: 60px;
  }
  
  .icon-wrapper i {
    font-size: 1.8rem;
  }
}

/* ========================================
   TIME INPUT STYLES
======================================== */

 .time-input {
   font-size: 0.8rem;
   padding: 0.35rem 0.5rem;
   min-height: 34px;
   min-width: 80px;
   max-width: 90px;
   width: 100%;
   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
   font-weight: 600;
   letter-spacing: 0.2px;
   text-align: center;
   border-radius: 6px;
   border: 1.5px solid #ced4da;
   transition: all 0.3s ease;
 }

.time-input::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}

.time-input:focus {
  border-color: #6bd098;
  box-shadow: 0 0 0 0.2rem rgba(107, 208, 152, 0.25);
}

/* Para Firefox */
.time-input[type="time"] {
  -moz-appearance: textfield;
}

/* Para asegurar que el texto sea visible en todos los navegadores */
.time-input::-webkit-datetime-edit-text,
.time-input::-webkit-datetime-edit-hour-field,
.time-input::-webkit-datetime-edit-minute-field,
.time-input::-webkit-datetime-edit-second-field {
  color: #495057;
  font-weight: 500;
}

/* Estilo cuando está deshabilitado */
.time-input:disabled {
  background-color: #f8f9fa;
  opacity: 0.6;
}

/* Estilo para error */
.time-input.is-invalid {
  border-color: #dc3545;
}

.time-input.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

 /* ========================================
    DAY CONTAINER STYLES
 ======================================== */
 
 .day-card {
   min-height: 160px;
   transition: all 0.3s ease;
   border: 2px solid #e9ecef;
 }
 
 .day-card.border-success {
   border-color: #6bd098 !important;
   box-shadow: 0 4px 15px rgba(107, 208, 152, 0.2);
 }
 
 .day-card .card-header {
   background: #f8f9fa;
   border-bottom: 1px solid #e9ecef;
   min-height: 50px;
   display: flex;
   align-items: center;
 }
 
 .day-card.border-success .card-header {
   background: linear-gradient(135deg, rgba(107, 208, 152, 0.1) 0%, rgba(107, 208, 152, 0.05) 100%);
   border-bottom-color: #6bd098;
 }
 
 .day-card .card-body {
   padding: 8px;
   min-height: 80px;
 }
 
 /* Estilos específicos para el contenedor de horarios */
 .day-card .card-body .row .col-6 {
   padding-left: 6px;
   padding-right: 6px;
   margin-bottom: 2px;
 }
 
 .day-card .card-body .row {
   margin-left: -6px;
   margin-right: -6px;
 }

 /* Responsive styles para campos de tiempo y contenedores */
 @media (max-width: 768px) {
   .time-input {
     min-width: 75px;
     max-width: 85px;
     font-size: 0.75rem;
     padding: 0.3rem 0.45rem;
   }
   
   .day-card {
     min-height: 140px;
   }
   
   .day-card .card-body {
     padding: 6px;
     min-height: 70px;
   }
 }
 
 @media (max-width: 576px) {
   .time-input {
     min-width: 70px;
     max-width: 80px;
     font-size: 0.7rem;
     padding: 0.25rem 0.4rem;
   }
   
   .day-card .card-body .row .col-6 {
     padding-left: 4px;
     padding-right: 4px;
     margin-bottom: 1px;
   }
   
   .day-card .card-body .row {
     margin-left: -4px;
     margin-right: -4px;
   }
   
   .day-card {
     min-height: 120px;
   }
   
   .day-card .card-body {
     padding: 5px;
     min-height: 60px;
   }
 }
 
 /* Mejoras adicionales para labels */
 .day-card .card-body label.small {
   font-weight: 600;
   color: #495057;
   margin-bottom: 2px;
   font-size: 0.75rem;
 }

/* ========================================
   MODAL FOOTER STYLES
======================================== */

.modal-footer-custom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  gap: 15px;
}

.btn-modal {
  min-width: 120px;
  padding: 10px 20px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-modal i {
  font-size: 0.9rem;
}

.btn-modal:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-modal.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

.btn-modal.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}

.btn-modal.btn-primary {
  background-color: #6bd098;
  border-color: #6bd098;
  color: white;
}

.btn-modal.btn-primary:hover:not(:disabled) {
  background-color: #5cb85c;
  border-color: #5cb85c;
}

.btn-modal.btn-primary:disabled {
  opacity: 0.7;
  transform: none;
  cursor: not-allowed;
}

.btn-modal.btn-warning {
  background-color: #f39c12;
  border-color: #f39c12;
  color: white;
}

.btn-modal.btn-warning:hover {
  background-color: #e67e22;
  border-color: #d68910;
}

/* Responsive Modal Footer */
@media (max-width: 576px) {
  .modal-footer-custom {
    flex-direction: column;
    gap: 10px;
    padding: 0 10px;
  }
  
  .btn-modal {
    width: 100%;
    min-width: auto;
  }
}
</style> 